import * as UI from './ui';

document.addEventListener("DOMContentLoaded", function () {
    UI.DropDown.init();
});


window.flowboxEvents = [];
$.notifyDefaults().z_index = 99999999;


var product = $('.js-product');
product.find('.image').hoverIntent(
    function () {
        $(this).find('.alt-image').show();
    },
    function () {
        $(this).find('.alt-image').hide();
    }
);

$('.clickable').on('mousedown', function (e) {
    if ($(this).attr('href')) {
        if (e.which == 1) {
            e.preventDefault();
            window.location = $(this).attr('href');
        }
        if (e.which == 2) {
            e.preventDefault();
            window.open($(this).attr('href'), '_blank');
        }
    }
})

$('.clickable_blank').on('click', function (e) {
    if ($(this).attr('href')) {
        e.preventDefault();
        window.open($(this).attr('href'), '_blank');
    }
})

// MOBILE TOTOP
if ($(window).width() < 560) {
    if (($(window).height() + 100) < $(document).height()) {
        if($('#top-link-block')) {
            $('#top-link-block').removeClass('hidden').affix({
                offset: {
                    top: 100
                }
            });
        }
    }
}

$('.js-back-to-top').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({
        scrollTop: 0
    }, 800);
});

// INFO MODAL
$(document).on('click', '.js-info-modal', function (e) {
    e.preventDefault();
    var $this = $(this),
        content = $this.data('content'),
        img = $this.data('img'),
        modal = $('#js-info-modal');

    if (img) {
        content = '<div class="row"><div class="col-xs-6">' + content + '</div><div class="col-xs-6"><img src="' + img + '" class="img-responsive"></div></div>';
    } else {
        content = '<div class="row"><div class="col-xs-12">' + content + '</div></div>';
    }
    modal.find('.modal-body').html(content);
    modal.modal('show');
    $("body").css({"height":"auto"});

});
$('.js-goto').on('click', function (e) {
    e.preventDefault();
    $('html, body').stop();

    let headerHeight;
    let offset = $(this).data('extra') || 0;

    if ($(window).width() > 1200) {
        headerHeight = 350;
    } else {
        headerHeight = 200;
    }

    const gotoElement = $(this),
        gotoElementHref = gotoElement.attr('href'),
        gotoElementID = gotoElement.data('href');

    if ($(this).hasClass('js-open-dimension')) {
        if ($(this).hasClass('js-dimentions')) {

            $('.panel').find('.panel-title').find('a').removeClass('collapsed');
            $('.panel').find('.in').removeClass('in');
            if ($(gotoElementID).parent().parent().hasClass('collapse')) {
                $(gotoElementID).parent().parent().removeClass('collapse');
            }
            $(gotoElementID).find('a').addClass('collapsed');
            $(gotoElementID).parent().parent().parent().parent().find('.panel-collapse').addClass('in').attr('style', '');

        } else {
            $('.panel').find('.panel-title').find('a').removeClass('collapsed');
            $('.panel').find('.in').removeClass('in');
            if ($(gotoElementID).hasClass('collapse')) {
                $(gotoElementID).removeClass('collapse');
            }
            $(gotoElementID).find('a').addClass('collapsed');
            $(gotoElementID).parent().find('.panel-collapse').addClass('in').attr('style', '');
        }
    }
    const gotoElementTop = $(gotoElementHref).offset().top,
        gotoHeaderHeight = headerHeight;

    if (gotoElementTop && gotoHeaderHeight) {
        $('html, body').animate({
            scrollTop: gotoElementTop - gotoHeaderHeight
        }, 800);
    }
});


if (document.getElementById('js-popup-modal')) {
    setTimeout(function () {
        $('#js-popup-modal').modal({ keyboard: true, backdrop: 'static' });
    }, 3000);

    $('#js-popup-modal').on('click', function (e) {
        if (!$(e.delegateTarget).hasClass('.modal-dialog')) {
            $('#js-popup-modal').modal('hide');
        }
    });
}

if (document.getElementById('js-user-login-modal')) {
    $('#js-user-login-modal').modal({ 'keyboard': false, 'backdrop': 'static' });
}

if (document.querySelector('[data-datalayer-user]')) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'logged_in',
        'userID': document.querySelector('[data-datalayer-user]').dataset.datalayerUser, 
        'email': document.querySelector('[data-datalayer-useremail]').dataset.datalayerUseremail 
    });
}

const iosViewportHeight = () => {
    let vh = (window.visualViewport ? window.visualViewport.height : window.innerHeight) * 0.01;

    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

iosViewportHeight();

window.addEventListener('resize', () => {
    iosViewportHeight();
});

window.addEventListener('focus', function(e) {
    if(document.body.classList.contains('modal-open')) {
        const OPEN_MODAL = document.querySelector('.modal.in');
        if(OPEN_MODAL) {
            OPEN_MODAL.focus();
        }
    }
});

const JS_ORDER_SIDEBAR = document.querySelectorAll('.product-options');
if(JS_ORDER_SIDEBAR.length) {
    JS_ORDER_SIDEBAR.forEach(sidebar => {
        const OPTIONS = sidebar.querySelectorAll('[name^="option"]');
        const URL = sidebar.dataset.action;
        
        OPTIONS.forEach(function(OPTION) {
            OPTION.addEventListener('change', function(e) {
                let productOptions = [];
                if(OPTION.dataset.id) {
                    productOptions.push({'id': OPTION.dataset.id, 'quantity': 1});
                }
                const REQUEST = new XMLHttpRequest();
                REQUEST.open("POST", URL, true);
                REQUEST.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
                REQUEST.send(JSON.stringify(productOptions));
            });
        });
    })
}

const moreInfoIcon = document.querySelectorAll('[data-js-more-info-btn]');

moreInfoIcon.forEach(item => {
    if (item) {
        const modal = document.querySelector('#js-more-info-modal');

        item.addEventListener('click', (e) => {
            const title = e.currentTarget.getAttribute('data-title'),
                content = e.currentTarget.getAttribute('data-content');

            modal.querySelector('.modal-title').innerHTML = title;
            modal.querySelector('.content').innerHTML = content;
            document.body.style.height = 'auto';
            document.body.style.position = 'unset';
        })
    }
})

window.onload = function(e) {
    const IMAGE_BUSTING = document.querySelectorAll('[data-js-image-bust]');
    
    IMAGE_BUSTING.forEach(img => {
        let imgSrc = img.getAttribute('data-src'),
            num = Math.floor(Math.random() * 1000000000);
        const newName = imgSrc +'?q=' + new Date().getTime();
        
        img.setAttribute('data-src', newName);
    });
}

const ALL_PASSWORD_TOGGLES = document.querySelectorAll('.password-toggle');
        
function togglePasswordFieldType(event) {
    const TOGGLE = event.target;
    const SHOW_TEXT = TOGGLE.src.replace('icon_eye_closed', 'icon_eye');
    const HIDE_TEXT = TOGGLE.src.replace('icon_eye', 'icon_eye_closed');
    const INPUT = TOGGLE.parentElement.querySelector('input');
    const STATE = INPUT.getAttribute('type');

    INPUT.setAttribute('type', STATE != 'text' ? 'text' : 'password');
    TOGGLE.src = STATE != 'text' ? HIDE_TEXT : SHOW_TEXT;
}

[...ALL_PASSWORD_TOGGLES].forEach((toggle) => {
    const INPUT = toggle.parentElement.querySelector('input');

    if(INPUT) toggle.addEventListener('click', togglePasswordFieldType);
});

const hasKleurstaalParam = (window.location.hash === '#kleurstaal');

if(hasKleurstaalParam) {
   $('#stofstaal-modal').modal('show');
}
